import "../assets/css/Home.css";
import React from "react";
import { useState, useEffect } from "react";
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
  DISPATCH_ACTION,
} from "@paypal/react-paypal-js";

import { v4 as uuidv4 } from "uuid";

var CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
interface OptionProps {
  clientId: any;
  currency: string;
  intent: string;
  disableFunding: string;
}
const initialOptions: OptionProps = {
  clientId: CLIENT_ID,
  currency: "USD",
  intent: "capture",
  disableFunding: "paylater",
};
interface PayPalComponentProps {
  isFormValid: boolean;
  setCalendlyActive: any;
}
const PayPalComponent: React.FC<PayPalComponentProps> = ({
  isFormValid,
  setCalendlyActive,
}) => {
  return (
    <PayPalScriptProvider options={initialOptions}>
      <CheckOut
        isFormValid={isFormValid}
        setCalendlyActive={setCalendlyActive}
      />
    </PayPalScriptProvider>
  );
};
const CheckOut: React.FC<PayPalComponentProps> = ({
  isFormValid,
  setCalendlyActive,
}) => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

  const onCreateOrder = (data: any, actions: any) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: "4.99",
          },
        },
      ],
    });
  };

  const onApproveOrder = (data: any, actions: any) => {
    return actions.order.capture().then((details: any) => {
      const name = details.payer.name.given_name;

      setCalendlyActive(true);
    });
  };
  return (
    <div>
      {" "}
      <PayPalButtons
        style={{ layout: "vertical" }}
        createOrder={(data, actions) => onCreateOrder(data, actions)}
        onApprove={(data, actions) => onApproveOrder(data, actions)}
        disabled={!isFormValid}
        onCancel={() => {
          console.log("cancelled");
        }}
        onError={(err) => {
          console.error("PayPal error:", err);
        }}
      />
    </div>
  );
};

export default PayPalComponent;
